import { FC, Fragment } from 'react';
import { useTranslation } from 'next-i18next';
import { Divider, Typography } from 'antd';

import { Container } from '@/shared/components/layout';
import { PrivateDocumentCategory } from '@/shared/lib/sj-orm/models/document/private.document.dto';

import { privateDocumentsCategoryI18nMap } from '../../document/helpers';

export const categoryList: PrivateDocumentCategory[] = [
  PrivateDocumentCategory.PRIVATE_AGREEMENTS,
  PrivateDocumentCategory.PUBLIC_AGREEMENTS,
  PrivateDocumentCategory.INFORMATION_SHEETS,
  PrivateDocumentCategory.BANK_DOCUMENTS,
  PrivateDocumentCategory.PAYMENT_DOCUMENTS,
  PrivateDocumentCategory.CORPORATE_DOCUMENTS,
  PrivateDocumentCategory.POWERS,
  PrivateDocumentCategory.FAMILY_DOCUMENTS,
  PrivateDocumentCategory.OTHER,
];

type PrivateDocumentCategoryListProps = {
  onSelect: (category: PrivateDocumentCategory) => void;
};

export const PrivateDocumentCategoryList: FC<PrivateDocumentCategoryListProps> = ({ onSelect }) => {
  const { t } = useTranslation('entities/privateDocuments', { keyPrefix: 'category' });

  return (
    <>
      {categoryList.map((iType) => (
        <Fragment key={iType}>
          <Divider style={{ margin: 0 }} />
          <Container paddingX={24} paddingY={16} style={{ cursor: 'pointer' }}>
            <Typography.Title level={4} onClick={() => onSelect(iType)}>
              {t(privateDocumentsCategoryI18nMap[iType])}
            </Typography.Title>
          </Container>
        </Fragment>
      ))}
    </>
  );
};
